/* global $ */

const NoteModal = {
  /**
   * Instantiate prompt
   * @param {HTMLElement} node
   * @return {void}
   */
  create(node) {
    this.node = node;

    $(node).on('show.bs.modal', (e) => {
      this.api = e.relatedTarget.dataset.noteApi;
      this.fetch();
    });
  },

  fetch() {
    window.axios.get(this.api)
      .then((res) => {
        this.outputData(res.data);
      });
  },

  outputData(data) {
    const $notes = $(this.node).find('.js-note-field');

    $notes.toArray().forEach((note) => {
      const $note = $(note);
      const noteKey = $note.data('note');
      $note.html(typeof data[noteKey] !== 'undefined' && data[noteKey] ? data[noteKey] : 'Geen notitie');
    });
  },
};

export default NoteModal;
